import { RmaEntityTypeCodes } from '@harvestiq/constants';

export enum BusinessType {
  BureauOfIndianAffairsAndIndianTribeTreaties = 'Bureau of Indian Affairs and Indian Tribe Treaties',
  Corporation = 'Corporation',
  Estates = 'Estates',
  IndividualOperatingAsABusiness = 'Individual Operating as a Business',
  JointOperations = 'Joint operations/ventures and co-ownerships',
  LandlordTenant = 'Landlord/Tenant',
  LimitedLiabilityCompany = 'Limited Liability Company',
  NonProfitOrganizations = 'Non-Profit or Tax-Exempt Organizations',
  TransferOfRightToIndemnity = 'Transfer of Right to Indemnity (SBI only)',
  Partnership = 'Partnership',
  PublicSchools = 'Public Schools',
  ReceiverOrLiquidator = 'Receiver or Liquidator',
  StateLocalGovernment = 'State/Local Government',
  TrustIrrevocable = 'Trust - Irrevocable',
  TrustRevocable = 'Trust - Revocable',
}

export const businessTypes = Object.values(BusinessType).filter(
  // Remove the landlord/tenant as it is not present in RMA and should not be an option
  (type) => type !== BusinessType.LandlordTenant
);

export const convertBusinessTypeToRmaEntityTypeCode = (
  type: BusinessType | undefined | null
) => {
  switch (type) {
    case BusinessType.BureauOfIndianAffairsAndIndianTribeTreaties:
      return RmaEntityTypeCodes.BureauOfIndianAffairsAndIndianTribeTreaties;
    case BusinessType.Corporation:
      return RmaEntityTypeCodes.Corporation;
    case BusinessType.Estates:
      return RmaEntityTypeCodes.Estates;
    case BusinessType.IndividualOperatingAsABusiness:
      return RmaEntityTypeCodes.IndividualOperatingAsABusiness;
    case BusinessType.JointOperations:
      return RmaEntityTypeCodes.JointOperationsVenturesAndCoOwnerships;
    case BusinessType.LandlordTenant:
      // NOTE: BusinessType.LandlordTenant is not present in RMA, coerce to LLC
      return RmaEntityTypeCodes.LimitedLiabilityCompany;
    case BusinessType.LimitedLiabilityCompany:
      return RmaEntityTypeCodes.LimitedLiabilityCompany;
    case BusinessType.NonProfitOrganizations:
      return RmaEntityTypeCodes.NonProfitOrTaxExemptOrganizations;
    case BusinessType.Partnership:
      return RmaEntityTypeCodes.Partnership;
    case BusinessType.PublicSchools:
      return RmaEntityTypeCodes.PublicSchools;
    case BusinessType.ReceiverOrLiquidator:
      return RmaEntityTypeCodes.ReceiverOrLiquidator;
    case BusinessType.StateLocalGovernment:
      return RmaEntityTypeCodes.StateLocalGovernment;
    case BusinessType.TrustIrrevocable:
      return RmaEntityTypeCodes.TrustIrrevocable;
    case BusinessType.TrustRevocable:
      return RmaEntityTypeCodes.TrustRevocable;
    default:
      return null;
  }
};

export const getBusinessTypeFromRmaEntityTypeCodes = (
  code: string
): BusinessType => {
  switch (code) {
    case RmaEntityTypeCodes.PublicSchools:
      return BusinessType.PublicSchools;
    case RmaEntityTypeCodes.BureauOfIndianAffairsAndIndianTribeTreaties:
      return BusinessType.BureauOfIndianAffairsAndIndianTribeTreaties;
    case RmaEntityTypeCodes.Corporation:
      return BusinessType.Corporation;
    case RmaEntityTypeCodes.Estates:
      return BusinessType.Estates;
    case RmaEntityTypeCodes.NonProfitOrTaxExemptOrganizations:
      return BusinessType.NonProfitOrganizations;
    case RmaEntityTypeCodes.TransferOfRightToIndemnity:
      return BusinessType.TransferOfRightToIndemnity;
    case RmaEntityTypeCodes.ReceiverOrLiquidator:
      return BusinessType.ReceiverOrLiquidator;
    case RmaEntityTypeCodes.StateLocalGovernment:
      return BusinessType.StateLocalGovernment;
    case RmaEntityTypeCodes.IndividualOperatingAsABusiness:
      return BusinessType.IndividualOperatingAsABusiness;
    case RmaEntityTypeCodes.JointOperationsVenturesAndCoOwnerships:
      return BusinessType.JointOperations;
    case RmaEntityTypeCodes.LimitedLiabilityCompany:
      return BusinessType.LimitedLiabilityCompany;
    case RmaEntityTypeCodes.Partnership:
      return BusinessType.Partnership;
    case RmaEntityTypeCodes.TrustRevocable:
      return BusinessType.TrustRevocable;
    case RmaEntityTypeCodes.TrustIrrevocable:
      return BusinessType.TrustIrrevocable;
    default:
      throw new Error(`Unknown RMA entity type code: ${code}`);
  }
};
